/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_BoldInputs */

const en_common_editor_bold = /** @type {(inputs: Common_Editor_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bold`)
};

const zh_common_editor_bold = /** @type {(inputs: Common_Editor_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加粗`)
};

/**
* | output |
* | --- |
* | "Bold" |
*
* @param {Common_Editor_BoldInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_bold = /** @type {((inputs?: Common_Editor_BoldInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_BoldInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_bold(inputs)
	return zh_common_editor_bold(inputs)
});
export { common_editor_bold as "common.editor.bold" }